module.exports = __webpack_public_path__ + "static/media/nf.335f75bc.svg";